import { Link } from 'react-router-dom';

const cols = [
  {
    title: '档案导航',
    links: [
      { label: '档案首页', to: '/' },
      { label: '实锤证据库', to: '/archive' },
      { label: '辟谣反锤', to: '/archive?view=debunk' },
      { label: '关于我们', to: '/about' },
    ],
  },
  {
    title: '快速索引',
    links: [
      { label: '按人物检索', to: '/archive?q=人物' },
      { label: '按事件检索', to: '/archive?q=事件' },
      { label: '按时间检索', to: '/archive?q=时间' },
      { label: '转账记录补档', to: '/archive?type=transfer' },
    ],
  },
  {
    title: '互动与帮助',
    links: [
      { label: '常见问题', to: '/faq' },
      { label: '投稿与线索', to: '/about#contact' },
      { label: '内容原则', to: '/about#principles' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 text-foreground-800 border-t border-background-200">
      <div className="px-4 md:px-6 lg:px-10 pt-12 md:pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="stamp text-sm font-bold px-2 py-0.5">69</span>
              <span className="leading-none">
                <span className="block font-display font-bold text-foreground-950 text-lg">69爆料</span>
                <span className="block text-[10px] tracking-[0.3em] text-foreground-500 mt-0.5">
                  实锤证据汇总库
                </span>
              </span>
            </Link>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-md">
              一个把「吃瓜材料」整理成「可核验档案」的中立信息站：按事件、人物、时间归拢聊天截图、转账记录、录音影像等公开素材，逐条标注来源，同步收录辟谣反锤。
            </p>
            <p className="mt-3 text-xs text-foreground-500 leading-relaxed max-w-md">
              站内档案仅作公开信息整理与检索参考，不构成对任何事件与个人的定性结论，请以当事方正式声明及监管、司法结论为准。
            </p>
            <div className="mt-4 flex items-center gap-3 text-foreground-500">
              <span className="inline-flex items-center gap-1.5 text-xs">
                <i className="ri-mail-line"></i>contact@69bao.cn
              </span>
              <span className="inline-flex items-center gap-1.5 text-xs">
                <i className="ri-shield-check-line"></i>来源可溯 · 脱敏处理
              </span>
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-display font-semibold text-foreground-950 text-sm mb-3">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="inline-flex items-center gap-1.5 text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <p>© 2026 69爆料 · 实锤证据汇总库。仅作公开信息整理与档案检索用途。</p>
          <p className="inline-flex items-center gap-2">
            <i className="ri-shield-keyhole-line"></i>隐私与合规 · 来源规范 · 不站队
          </p>
        </div>
      </div>
    </footer>
  );
}